export const greekHolidays: Record<string, string> = {
  '2025-01-01': 'Πρωτοχρονιά',
  '2025-01-06': 'Θεοφάνεια',
  '2025-03-03': 'Καθαρά Δευτέρα',
  '2025-03-25': 'Εθνική Εορτή',
  '2025-04-18': 'Μεγάλη Παρασκευή',
  '2025-04-20': 'Κυριακή του Πάσχα',
  '2025-04-21': 'Δευτέρα του Πάσχα',
  '2025-05-01': 'Εργατική Πρωτομαγιά',
  '2025-06-09': 'Αγίου Πνεύματος',
  '2025-08-15': 'Κοίμηση της Θεοτόκου',
  '2025-10-28': 'Εθνική Εορτή',
  '2025-12-25': 'Χριστούγεννα',
  '2025-12-26': '2η μέρα Χριστουγέννων',
  '2026-01-01': 'Πρωτοχρονιά',
  '2026-01-06': 'Θεοφάνεια',
  '2026-02-23': 'Καθαρά Δευτέρα',
  '2026-03-25': 'Εθνική Εορτή',
  '2026-04-10': 'Μεγάλη Παρασκευή',
  '2026-04-12': 'Κυριακή του Πάσχα',
  '2026-04-13': 'Δευτέρα του Πάσχα',
  '2026-05-01': 'Εργατική Πρωτομαγιά',
  '2026-06-01': 'Αγίου Πνεύματος',
  '2026-08-15': 'Κοίμηση της Θεοτόκου',
  '2026-10-28': 'Εθνική Εορτή',
  '2026-12-25': 'Χριστούγεννα',
  '2026-12-26': '2η μέρα Χριστουγέννων',
  '2027-01-01': 'Πρωτοχρονιά',
  '2027-01-06': 'Θεοφάνεια',
  '2027-03-15': 'Καθαρά Δευτέρα',
  '2027-03-25': 'Εθνική Εορτή',
  '2027-04-30': 'Μεγάλη Παρασκευή',
  '2027-05-02': 'Κυριακή του Πάσχα',
  '2027-05-03': 'Δευτέρα του Πάσχα',
  '2027-05-01': 'Εργατική Πρωτομαγιά',
  '2027-06-21': 'Αγίου Πνεύματος',
  '2027-08-15': 'Κοίμηση της Θεοτόκου',
  '2027-10-28': 'Εθνική Εορτή',
  '2027-12-25': 'Χριστούγεννα',
  '2027-12-26': '2η μέρα Χριστουγέννων',
  '2028-01-01': 'Πρωτοχρονιά',
  '2028-01-06': 'Θεοφάνεια',
  '2028-02-28': 'Καθαρά Δευτέρα',
  '2028-03-25': 'Εθνική Εορτή',
  '2028-04-14': 'Μεγάλη Παρασκευή',
  '2028-04-16': 'Κυριακή του Πάσχα',
  '2028-04-17': 'Δευτέρα του Πάσχα',
  '2028-05-01': 'Εργατική Πρωτομαγιά',
  '2028-06-05': 'Αγίου Πνεύματος',
  '2028-08-15': 'Κοίμηση της Θεοτόκου',
  '2028-10-28': 'Εθνική Εορτή',
  '2028-12-25': 'Χριστούγεννα',
  '2028-12-26': '2η μέρα Χριστουγέννων',
};
